import { render, staticRenderFns } from "./ClassService.vue?vue&type=template&id=1877632e&"
import script from "./ClassService.vue?vue&type=script&lang=js&"
export * from "./ClassService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports